export default __webpack_public_path__ + "media/src/usersite/images/header/sns_banners/sp_sns_insta-14934d495bf9d94481e5e01c5bd0c019.png";